export const dict = {
	custom: {
		name: {
			required: "Please enter your company name here",
		},
		address: {
			required: "Please enter your address here",
		},
		phone: {
			required: "Please enter your phone here",
			numeric: "Your phone may only contain numeric characters",
		},
		nit: {
			required: "Please enter your nit here",
		},
		date_init: {
			required: "The Date init is required",
		},
		date_end: {
			required: "The Date end is required",
		},
		contac_persons: {
			required: "Please enter your contac persons",
			alpha: "Your contac_persons may only contain alphabetic characters valid",
		},
		city: {
			required: "Please enter your city here",
		},
		country: {
			required: "Please enter your conuntry here",
		},
		description: {},
	},
};
